import { Action, createReducer, on } from '@ngrx/store';
import { IAsqPortfolioItem } from '../models/asq-portfolios.model';
import * as asqPortfoliosActions from '../actions/asq-portfolios.actions';

export const asqPortfoliosFeatureKey = 'asqPortfolios';

export interface AsqPortfoliosState {
  loadAsqPortfoliosResponse: IAsqPortfolioItem[];
  loadAsqPortfoliosFailure: Error | any;
}

export const initialState: AsqPortfoliosState = {
  loadAsqPortfoliosResponse: undefined,
  loadAsqPortfoliosFailure: undefined
};

export const reducer = createReducer(
  initialState,
  on(asqPortfoliosActions.loadAsqPortfoliosSuccess, (state, action) => ({
    ...state,
    loadAsqPortfoliosResponse: action.response
  })),
  on(asqPortfoliosActions.loadAsqPortfoliosFailure, (state, action) => ({
    ...state,
    loadAsqPortfoliosFailure: action.error
  }))
);

export const getAsqPortfolios = (state: AsqPortfoliosState) => state.loadAsqPortfoliosResponse;
